import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=0222625d&scoped=true&"
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"
import style0 from "./approval.vue?vue&type=style&index=0&id=0222625d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222625d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0222625d')) {
      api.createRecord('0222625d', component.options)
    } else {
      api.reload('0222625d', component.options)
    }
    module.hot.accept("./approval.vue?vue&type=template&id=0222625d&scoped=true&", function () {
      api.rerender('0222625d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/business_trip_application/form/components/approval.vue"
export default component.exports